<template>
    <header class="header-global">
        <base-nav class="navbar-main" transparent type="" effect="dark" expand>

            <div class="row" slot="content-header" slot-scope="{closeMenu}">
                <div class="col-12 collapse-close">
                    <close-button @click="closeMenu"></close-button>
                </div>
            </div>

            <ul class="navbar-nav navbar-nav-hover align-items-lg-center">
                <li class="nav-item">
                    <router-link to="/noise" class="nav-link">Noise</router-link>
                </li>
                <li class="nav-item">
                    <router-link to="/ping" class="nav-link">Ping</router-link>
                </li>
                <li class="nav-item">
                    <router-link to="/dice" class="nav-link">Dice</router-link>
                </li>
                <li class="nav-item">
                    <router-link to="/tip" class="nav-link">Tip</router-link>
                </li>
            </ul>
        </base-nav>
    </header>
</template>
<script>
import BaseNav from "@/components/BaseNav";
import BaseDropdown from "@/components/BaseDropdown";
import CloseButton from "@/components/CloseButton";

export default {
  components: {
    BaseNav,
    CloseButton,
    BaseDropdown
  }
};
</script>
<style scoped lang="css">
    .navbar-nav .nav-item:first-child a {
        padding-left: 0;
    }
    .navbar-transparent .navbar-nav .nav-link {
        color: rgba(255, 255, 255, 0.8);
        font-weight: bold;
    }
    .navbar-transparent .navbar-nav .show > .nav-link, .navbar-transparent .navbar-nav .active > .nav-link, .navbar-transparent .navbar-nav .nav-link.show, .navbar-transparent .navbar-nav .nav-link.active {
        color: rgba(255, 255, 255, 1.0);
        font-weight: bold;
    }
    .navbar-transparent .navbar-nav .nav-link:hover, .navbar-transparent .navbar-nav .nav-link:focus {
        color: rgba(255, 255, 255, 1.0);
        font-weight: bold;
    }
</style>
